module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-form', {
    model: {
      value: (_vm.isAddValid),
      callback: function($$v) {
        _vm.isAddValid = $$v
      },
      expression: "isAddValid"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-tabs', {
    attrs: {
      "slider-color": "grey"
    }
  }, [_c('v-tab', {
    key: 1,
    staticClass: "tab",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("Company Details")]), _vm._v(" "), _c('v-tab', {
    key: 2,
    staticClass: "tab",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("Region")]), _vm._v(" "), _c('v-tab-item', {
    key: 1,
    staticClass: "pl-4 pr-4 pt-4 pb-4"
  }, [_c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Company Type")]), _vm._v(" "), _c('v-select', {
    staticClass: "dropdown",
    attrs: {
      "items": _vm.companyTypes,
      "label": "Company Type",
      "rules": _vm.companyTypeRules,
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.companyType),
      callback: function($$v) {
        _vm.companyType = $$v
      },
      expression: "companyType"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Customer Code")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "dropdown",
    attrs: {
      "label": "Customer Code",
      "rules": _vm.customerCodeRules,
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.customerCode),
      callback: function($$v) {
        _vm.customerCode = $$v
      },
      expression: "customerCode"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Registration No.")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "dropdown",
    attrs: {
      "label": "Registration No",
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.registrationNo),
      callback: function($$v) {
        _vm.registrationNo = $$v
      },
      expression: "registrationNo"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Vat No.")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "dropdown",
    attrs: {
      "label": "Vat No",
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.vatNo),
      callback: function($$v) {
        _vm.vatNo = $$v
      },
      expression: "vatNo"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Name")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "dropdown",
    attrs: {
      "label": "Name",
      "rules": _vm.nameRules,
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Trading Name")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "dropdown",
    attrs: {
      "label": "Trading name",
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.tradingName),
      callback: function($$v) {
        _vm.tradingName = $$v
      },
      expression: "tradingName"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Address")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "dropdown",
    attrs: {
      "label": "Address",
      "rules": _vm.addressRules,
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.addressLine1),
      callback: function($$v) {
        _vm.addressLine1 = $$v
      },
      expression: "addressLine1"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Postal Code")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "dropdown",
    attrs: {
      "label": "Postal Code",
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.postalCode),
      callback: function($$v) {
        _vm.postalCode = $$v
      },
      expression: "postalCode"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Contact No.")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "dropdown",
    attrs: {
      "label": "Contact No",
      "rules": _vm.contactNoRules,
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.contactNo),
      callback: function($$v) {
        _vm.contactNo = $$v
      },
      expression: "contactNo"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Fax Number")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "dropdown",
    attrs: {
      "label": "Fax Number",
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.faxNumber),
      callback: function($$v) {
        _vm.faxNumber = $$v
      },
      expression: "faxNumber"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Email")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "dropdown",
    attrs: {
      "label": "Email",
      "autocomplete": "off",
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Contact Person")]), _vm._v(" "), _c('v-select', {
    staticClass: "dropdown",
    attrs: {
      "items": _vm.contactPerson,
      "label": "Contact Person",
      "rules": _vm.contactNoRules,
      "item-value": "id",
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.contactPerson),
      callback: function($$v) {
        _vm.contactPerson = $$v
      },
      expression: "contactPerson"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg8": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Notes")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "dropdown",
    attrs: {
      "label": "Notes",
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.notes),
      callback: function($$v) {
        _vm.notes = $$v
      },
      expression: "notes"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: 2,
    staticClass: "pl-4 pr-4 pt-4 pb-4"
  }, [_c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.userRegions != '') ? _c('v-data-table', {
    staticClass: "elevation-1 mainTable",
    attrs: {
      "headers": _vm.regionHeader,
      "search": _vm.search,
      "id": "hello",
      "items": _vm.userRegions,
      "hide-actions": "",
      "disable-initial-sort": "",
      "rows-per-page-items": [2000, 40, 60, 80, 100]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [_c('td', {
          attrs: {
            "width": "8%"
          }
        }, [_c('v-switch', {
          on: {
            "change": function($event) {
              return _vm.fncCheckRegionSetupCompany(props.item.loc_id, props.item.selected, props.item.parent)
            }
          },
          model: {
            value: (props.item.selected),
            callback: function($$v) {
              _vm.$set(props.item, "selected", $$v)
            },
            expression: "props.item.selected"
          }
        })], 1), _vm._v(" "), (props.expanded == true) ? _c('td', {
          staticClass: "cursor",
          attrs: {
            "width": "92%"
          },
          on: {
            "click": function($event) {
              props.expanded = !props.expanded
            }
          }
        }, [_vm._v(_vm._s(props.item.name) + " "), (props.item.children && props.item.children.length != 0) ? _c('i', {
          staticClass: "material-icons showHide"
        }, [_vm._v("arrow_upward")]) : _vm._e()]) : _c('td', {
          staticClass: "cursor",
          attrs: {
            "width": "92%"
          },
          on: {
            "click": function($event) {
              props.expanded = !props.expanded
            }
          }
        }, [_vm._v(_vm._s(props.item.name) + " "), (props.item.children && props.item.children.length != 0) ? _c('i', {
          staticClass: "material-icons showHide"
        }, [_vm._v("arrow_downward")]) : _vm._e()])])]
      }
    }, {
      key: "expand",
      fn: function(props) {
        return [(props.item.children != '') ? _c('v-data-table', {
          staticClass: "elevation-1 subTable subTable1",
          attrs: {
            "headers": _vm.regionHeader,
            "search": _vm.search,
            "items": props.item.children,
            "hide-actions": "",
            "disable-initial-sort": "",
            "rows-per-page-items": [20, 40, 60, 80, 100]
          },
          scopedSlots: _vm._u([{
            key: "items",
            fn: function(props) {
              return [_c('tr', [_c('td', {
                attrs: {
                  "width": "8%"
                }
              }, [_c('v-switch', {
                on: {
                  "change": function($event) {
                    return _vm.fncCheckRegionSetupCompany(props.item.loc_id, props.item.selected, props.item.parent)
                  }
                },
                model: {
                  value: (props.item.selected),
                  callback: function($$v) {
                    _vm.$set(props.item, "selected", $$v)
                  },
                  expression: "props.item.selected"
                }
              })], 1), _vm._v(" "), (props.expanded == true) ? _c('td', {
                staticClass: "cursor",
                attrs: {
                  "width": "92%"
                },
                on: {
                  "click": function($event) {
                    props.expanded = !props.expanded
                  }
                }
              }, [_vm._v(_vm._s(props.item.name) + " "), (props.item.children && props.item.children.length != 0) ? _c('i', {
                staticClass: "material-icons showHide"
              }, [_vm._v("arrow_upward")]) : _vm._e()]) : _c('td', {
                staticClass: "cursor",
                attrs: {
                  "width": "92%"
                },
                on: {
                  "click": function($event) {
                    props.expanded = !props.expanded
                  }
                }
              }, [_vm._v(_vm._s(props.item.name) + " "), (props.item.children && props.item.children.length != 0) ? _c('i', {
                staticClass: "material-icons showHide"
              }, [_vm._v("arrow_downward")]) : _vm._e()])])]
            }
          }, {
            key: "expand",
            fn: function(props) {
              return [(props.item.children != '') ? _c('v-data-table', {
                staticClass: "elevation-1 subTable2",
                attrs: {
                  "headers": _vm.regionHeader,
                  "search": _vm.search,
                  "items": props.item.children,
                  "hide-actions": "",
                  "disable-initial-sort": "",
                  "rows-per-page-items": [20, 40, 60, 80, 100]
                },
                scopedSlots: _vm._u([{
                  key: "items",
                  fn: function(props) {
                    return [_c('tr', [_c('td', {
                      attrs: {
                        "width": "8%"
                      }
                    }, [_c('v-switch', {
                      on: {
                        "change": function($event) {
                          return _vm.fncCheckRegionSetupCompany(props.item.loc_id, props.item.selected, props.item.parent)
                        }
                      },
                      model: {
                        value: (props.item.selected),
                        callback: function($$v) {
                          _vm.$set(props.item, "selected", $$v)
                        },
                        expression: "props.item.selected"
                      }
                    })], 1), _vm._v(" "), (props.expanded == true) ? _c('td', {
                      staticClass: "cursor",
                      attrs: {
                        "width": "92%"
                      },
                      on: {
                        "click": function($event) {
                          props.expanded = !props.expanded
                        }
                      }
                    }, [_vm._v(_vm._s(props.item.name) + " "), (props.item.children && props.item.children.length != 0) ? _c('i', {
                      staticClass: "material-icons showHide"
                    }, [_vm._v("arrow_upward")]) : _vm._e()]) : _c('td', {
                      staticClass: "cursor",
                      attrs: {
                        "width": "92%"
                      },
                      on: {
                        "click": function($event) {
                          props.expanded = !props.expanded
                        }
                      }
                    }, [_vm._v(_vm._s(props.item.name) + " "), (props.item.children && props.item.children.length != 0) ? _c('i', {
                      staticClass: "material-icons showHide"
                    }, [_vm._v("arrow_downward")]) : _vm._e()])])]
                  }
                }, {
                  key: "expand",
                  fn: function(props) {
                    return [(props.item.children != '') ? _c('v-data-table', {
                      staticClass: "elevation-1 subTable3",
                      attrs: {
                        "headers": _vm.regionHeader,
                        "search": _vm.search,
                        "items": props.item.children,
                        "hide-actions": "",
                        "disable-initial-sort": "",
                        "rows-per-page-items": [20, 40, 60, 80, 100]
                      },
                      scopedSlots: _vm._u([{
                        key: "items",
                        fn: function(props) {
                          return [_c('tr', [_c('td', {
                            attrs: {
                              "width": "8%"
                            }
                          }, [_c('v-switch', {
                            on: {
                              "change": function($event) {
                                return _vm.fncCheckRegionSetupCompany(props.item.loc_id, props.item.selected, props.item.parent)
                              }
                            },
                            model: {
                              value: (props.item.selected),
                              callback: function($$v) {
                                _vm.$set(props.item, "selected", $$v)
                              },
                              expression: "props.item.selected"
                            }
                          })], 1), _vm._v(" "), (props.expanded == true) ? _c('td', {
                            staticClass: "cursor",
                            attrs: {
                              "width": "92%"
                            },
                            on: {
                              "click": function($event) {
                                props.expanded = !props.expanded
                              }
                            }
                          }, [_vm._v(_vm._s(props.item.name) + " "), (props.item.children && props.item.children.length != 0) ? _c('i', {
                            staticClass: "material-icons showHide"
                          }, [_vm._v("arrow_upward")]) : _vm._e()]) : _c('td', {
                            staticClass: "cursor",
                            attrs: {
                              "width": "92%"
                            },
                            on: {
                              "click": function($event) {
                                props.expanded = !props.expanded
                              }
                            }
                          }, [_vm._v(_vm._s(props.item.name) + " "), (props.item.children && props.item.children.length != 0) ? _c('i', {
                            staticClass: "material-icons showHide"
                          }, [_vm._v("arrow_downward")]) : _vm._e()])])]
                        }
                      }], null, true)
                    }) : _vm._e()]
                  }
                }], null, true)
              }) : _vm._e()]
            }
          }], null, true)
        }) : _vm._e()]
      }
    }], null, false, 3657464193)
  }) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pl-4 pr-4 pb-4 buttonHolder"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right cancelButton",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncHideModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.runAdd) ? _c('v-progress-circular', {
    staticClass: "pt-3 loginLoader",
    attrs: {
      "indeterminate": "",
      "width": 3,
      "size": 20,
      "color": "grey"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.addressSelected == false) ? _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "success",
      "disabled": true
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncCreateCompany()
      }
    }
  }, [_vm._v("Save")]) : _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "success",
      "disabled": !_vm.isAddValid
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncCreateCompany()
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('small', [_vm._v("* The button will activate once all required fields have been completed.")])], 1)])], 1)], 1)], 1)
},staticRenderFns: []}